<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="SCM采购任务动态监控 center_12"></chart-title>
    <el-row id="center_12">
      <el-col :lg="8" :md="8" :sm="8" :xs="8">
        <div class="circlr_item" @click="jumpUrl(1)" >
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">
            {{
              getPercentage(
                  this.dataList.待处理申购单,
                  this.dataList.已处理申购单
              )
            }}%
          </span></dv-decoration-9
          >
          <div class="circlr_item_subtext">待处理申购单：{{this.dataList.待处理申购单}}</div>
          <div class="circlr_item_subtext">已处理申购单：{{this.dataList.已处理申购单}}</div>
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xs="8"
        ><div class="circlr_item"  @click="jumpUrl(1)" >
          <div class="circlr_item_subtext">审核中申购单：{{this.dataList.审核中申购单}}</div>
          <div class="circlr_item_subtext">完成审核申购单：{{this.dataList.完成审核申购单}}</div>
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">
            {{
              getPercentage(
                  this.dataList.审核中申购单,
                  this.dataList.完成审核申购单
              )
            }}%
          </span></dv-decoration-9
          >
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xs="8"
        ><div class="circlr_item"  @click="jumpUrl(2)" >
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">
            {{
              getPercentage(
                  this.dataList.待处理采购单,
                  this.dataList.已入库采购单
              )
            }}%
          </span></dv-decoration-9
          >
          <div class="circlr_item_subtext">待处理采购单：{{this.dataList.待处理采购单}}</div>
          <div class="circlr_item_subtext">已入库采购单：{{this.dataList.已入库采购单}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { purchaseCount } from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_12",
  components: { ChartTitle },
  data() {
    return {
      dataList: []
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      purchaseCount().then((resp) => {
        this.dataList = resp.data;
      });
    },
    getPercentage(v1, v2) {
      const nv1 = Number(v1);
      const nv2 = Number(v2);
      if (nv1 + nv2 == 0) {
        return 0;
      } else {
        return ((nv2 / (nv1 + nv2)) * 100).toFixed(2);
      }
    },
    jumpUrl(type){
      if(type === 1){
          //跳转申购单
          window.open(
              `${process.env.VUE_APP_JYL_URL}/#/login?nameJSC=purchase-order&username=${process.env.VUE_APP_NAME_SCM}&password=${process.env.VUE_APP_PASS}`,
              "_blank"
          );
      }
      else{
          //跳转采购单
          window.open(
              `${process.env.VUE_APP_JYL_URL}/#/login?nameJSC=purchase-index1&username=${process.env.VUE_APP_NAME_SCM}&password=${process.env.VUE_APP_PASS}`,
              "_blank"
          );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 27vh;
  #center_12 {
    height: calc(100% - 30px);
    padding: 0 24px;
    .circlr_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      .circlr {
        height: 110px;
        width: 110px;
        margin-bottom: 16px;
        .circlr_text {
          color: #DCDFE6;
          font-size: 18px;
          font-weight: bold;
        }
      }
      .circlr_item_subtext {
        color: #EBEEF5;
        margin-bottom: 6px;
      }
    }
  }
}
</style>
